// extracted by mini-css-extract-plugin
export var checkbox = "_42-0";
export var circle = "_42-3";
export var horizontalContainer = "_42-7";
export var sm = "_42-5";
export var switch0 = "_42-2";
export var switchDisabled = "_42-8";
export var switchEnabled = "_42-1";
export var textSwitchContainer = "_42-9";
export var textSwitchOption = "_42-a";
export var textSwitchOptionSelected = "_42-b";
export var verticalContainer = "_42-6";
export var xs = "_42-4";